
export type TenantPublicConfig = {
    tenant: string;
    baseUrl: string;                 // e.g. https://acme.tailvation.app
    auth: {
        provider: 'auth0';
        domain: string;                // acme.eu.auth0.com
        clientId: string;              // public id
        audience?: string;
    };
    api?: { baseUrl?: string };      // optional: https://api.tailvation.app
    ui?: { logoUrl?: string; primaryColor?: string };
};

export async function fetchTenantConfig(tenant: string): Promise<TenantPublicConfig> {
    const res = await fetch(`${process.env.REACT_APP_BACK_API}/tenant-config`, {
        headers: { 'X-Tenant': tenant }
    });
    if (!res.ok) throw new Error(`Config load failed (${res.status})`);
    return res.json();
}
